export const newWeddingsDate = '2023-04-04T09:00:00.000Z';
export const WORDS_PER_MINUTE = 250;
